import script from "./CampoFirma.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoFirma.vue?vue&type=script&setup=true&lang=js"

import "./CampoFirma.vue?vue&type=style&index=0&id=43c11835&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c11835"]])

export default __exports__